import { render, staticRenderFns } from "./app_01_Food.vue?vue&type=template&id=b09c0d48&lang=pug&"
import script from "./app_01_Food.vue?vue&type=script&lang=js&"
export * from "./app_01_Food.vue?vue&type=script&lang=js&"
import style0 from "./app_01_Food.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports